// extracted by mini-css-extract-plugin
export var section = "styles-module--section--2ntWq";
export var title = "styles-module--title--1m8j1";